const API_URL = import.meta.env.VITE_API_URL || "http://localhost:3001";

export const USER_ENDPOINTS = {
  REGISTER: `${API_URL}/users/register`,
  LOGIN: `${API_URL}/users/auth`,
  OAUTH_CALLBACK: `${API_URL}/users/auth/oauth-callback`,
  LOGOUT: `${API_URL}/users/logout`,
  ME: `${API_URL}/users/me`,
  FORGOT_PASSWORD: `${API_URL}/users/forgot-password`,
  RESET_PASSWORD: `${API_URL}/users/reset-password`,
  PROFILE: `${API_URL}/users/profile`,
  CHANGE_PASSWORD: `${API_URL}/users/change-password`,
  REQUEST_EMAIL_CHANGE: `${API_URL}/users/request-email-change`,
  VERIFY_EMAIL_CHANGE: `${API_URL}/users/verify-email-change`,
} as const;

export default USER_ENDPOINTS;
